// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SnqH","newExpiryDate":"styles_newExpiryDate__3r5Fq","footer":"styles_footer__3TZVS"};